import React, { useEffect, useState } from 'react';
import {
  Platform,
  createUseStyles,
  // getChatFindConversations,
  routesName,
  useLang,
  userInfo,
} from 'core/src';
import {
  Button,
  Spacing,
  Typography,
  Avatar,
  Container,
  MainHeader,
  FloatButton,
} from 'components/src';
import { FlatList, View } from 'react-native';
import { StackNavigationProp } from '@react-navigation/stack';
import { SocketIOContext } from '../../app/appcontainer';
// import { useInfiniteQuery } from '@tanstack/react-query';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import Fontisto from 'react-native-vector-icons/Fontisto';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import AntDesign from 'react-native-vector-icons/AntDesign';
import { useTranslation } from 'react-i18next';
import { TabBar, TabView } from 'react-native-tab-view';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const FontistoX = Fontisto as unknown as React.ComponentType<any>;
const AntDesignX = AntDesign as unknown as React.ComponentType<any>;
const MaterialCommunityIconsX =
  MaterialCommunityIcons as unknown as React.ComponentType<any>;

interface User {
  id: any;
  participants: any;
  lastMessage: any;
  type: any;
  title: any;
  totalUnread: number;
  tagged: boolean;
  isPinned: boolean;
}
interface ConversationScreen {
  navigation: StackNavigationProp<any>;
  setOpenChat?: any;
  dispatching?: any;
  setInfo?: any;

  chatInfo?: any;
  setOpen?: any;
}

const ConversationScreen: React.FC<ConversationScreen> = ({
  navigation,
  setOpenChat,
  setInfo,
  setOpen,
  dispatching,
  chatInfo,
}) => {
  const { styles, colors, theme } = useStyles();
  const { lang } = useLang();
  const { userName } = userInfo();
  const { i18n } = useTranslation();
  const [conversationList, setCoversationList] = useState([]);
  const [conversationListPrivate, setCoversationListPrivate] = useState([]);
  const [conversationListGroup, setCoversationListGroup] = useState([]);
  const [conversationListChannel, setCoversationListChannel] = useState([]);
  const [updateId, setUpdateId] = useState([]);
  const [success, setSuccess] = useState(false);
  const [index, setIndex] = useState(0);
  const [searchText, setSearchText] = useState<string>('');
  const [routes] = useState([
    { key: 'all', title: i18n.t('allChat') },
    { key: 'private', title: i18n.t('private') },
    { key: 'group', title: i18n.t('group') },
    { key: 'channel', title: i18n.t('channel') },
  ]);

  SocketIOContext.useSocketEffect<any, any>(
    'refetch',
    (event: any): any => {
      setUpdateId(event?.getOneMessageOfConversations);
    },
    [],
  );

  useEffect(() => {
    SocketIOContext.invoke('findConversations', {
      pageNumber: '1',
      pageSize: '200',
      title: searchText,
    });
  }, [success, searchText]);

  SocketIOContext.useSocketEffect<any, any>(
    'connectionSuccess',
    (event: any): any => {
      setSuccess(true);
    },
    [],
  );

  SocketIOContext.useSocketEffect<any, any>(
    'findConversations',
    (event: any): any => {
      setCoversationList(event?.result?.getOneMessageOfConversations);
    },
    [],
  );

  function replaceAndMoveToTop(list: any[], updateIds: any[]) {
    updateIds?.forEach((updateId) => {
      const id = updateId.id;
      const index = list.findIndex((item: any) => item.id === id);

      if (index !== -1) {
        list[index] = updateId;
      } else {
        !searchText && list.unshift(updateId);
      }
    });

    !searchText &&
      list?.sort((a, b) => {
        if (a.isPinned && !b.isPinned) {
          return -1;
        }
        if (!a.isPinned && b.isPinned) {
          return 1;
        }

        const dateA = new Date(a.lastMessage?.created_at || 0).getTime();
        const dateB = new Date(b.lastMessage?.created_at || 0).getTime();
        return dateB - dateA;
      });

    return list;
  }

  useEffect(() => {
    replaceAndMoveToTop(conversationList, updateId);
    setCoversationListPrivate(
      conversationList?.filter((item: any) => item?.type === 'privateChat'),
    );
    setCoversationListGroup(
      conversationList?.filter((item: any) => item?.type === 'group'),
    );
    setCoversationListChannel(
      conversationList?.filter((item: any) => item?.type === 'channel'),
    );
  }, [conversationList, updateId, searchText]);

  const handleChatInfo = (ownerChat: string, item: any, status: string) => {
    const avatar =
      item?.type === 'savedMessages'
        ? '37329gb39782gd3gbd382gd@@saved_messages_pic.png'
        : item?.type !== 'privateChat'
          ? ''
          : item.participants.find(
              (participant: any) => participant.user.user_name !== userName,
            )?.user.avatar;

    dispatching(
      setInfo({
        name: ownerChat,
        chatId: item?.id,
        avatar: avatar,
        status: status,
        unread: item?.totalUnread,
      }),
    );
    setOpenChat('staging');
    setTimeout(() => {
      setOpenChat('chat');
    }, 200);
  };

  const renderScene = ({ route }: any) => {
    if (conversationList === undefined && !searchText) {
      return (
        <View
          style={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            text={i18n.t('ThereIsNotAnyConversation')}
            size={16}
            textAlign={'center'}
            margin={10}
          />

          <Button
            onClick={handleButtonPress}
            flexDirection={'row'}
            classes={{
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: colors.menu,
              padding: 10,
              marginTop: 20,
            }}
          >
            <AntDesignX
              size={24}
              color={colors.white}
              name={'plus'}
              style={{
                padding: 2,
              }}
            />
            <Typography
              text={i18n.t('createChat')}
              color="#ddd"
              size={18}
              classes={{ marginTop: 5 }}
            />
          </Button>
        </View>
      );
    }
    switch (route.key) {
      case 'all':
        return (
          <FlatList
            data={conversationList}
            renderItem={renderItem}
            keyExtractor={(item: User) => item.id}
            // refreshing={_isFetching}
            // onRefresh={handleRefetch}
            // onEndReached={handleLoadMore}
            onEndReachedThreshold={0.1}
            showsVerticalScrollIndicator={false}
            // ListFooterComponent={() => (
            //   <View>{isFetchingNextPage && <ActivityIndicator />}</View>
            // )}
          />
        );
      case 'private':
        return (
          <FlatList
            data={conversationListPrivate}
            renderItem={renderItem}
            keyExtractor={(item: User) => item.id}
            onEndReachedThreshold={0.1}
            showsVerticalScrollIndicator={false}
          />
        );
      case 'group':
        return (
          <FlatList
            data={conversationListGroup}
            renderItem={renderItem}
            keyExtractor={(item: User) => item.id}
            onEndReachedThreshold={0.1}
            showsVerticalScrollIndicator={false}
          />
        );
      case 'channel':
        return (
          <FlatList
            data={conversationListChannel}
            renderItem={renderItem}
            keyExtractor={(item: User) => item.id}
            onEndReachedThreshold={0.1}
            showsVerticalScrollIndicator={false}
          />
        );
      default:
        return null;
    }
  };

  const handleButtonPress = () => {
    Platform.isDesktop
      ? setOpen('contact')
      : navigation.navigate(routesName.CONTACT);
  };

  const renderItem = ({ item }: { item: User }) => {
    const content = item?.lastMessage?.forward
      ? item?.lastMessage?.forward?.content
      : item?.lastMessage?.content;
    const contentByLine = content?.split('\n')[0] + content?.split('\n')[1];
    const lastMessage = content
      ? content?.split('\n').length > 2
        ? contentByLine + '...'
        : content?.substring(0, 10) + '...'
      : '';
    const lastMessageStatus = item?.lastMessage?.seen;

    const whoMustRead = item?.lastMessage?.sender?.user_name !== userName;

    const dateString = item?.lastMessage?.created_at;
    const originalDate = new Date(dateString);

    const options = {
      timeZone: 'Asia/Tehran',
      hour: '2-digit',
      minute: '2-digit',
      fractionalSecondDigits: 1,
    };
    //@ts-ignore
    const iranDateTimeString = originalDate.toLocaleString('en-US', options);

    let time = iranDateTimeString.substring(0, 5);

    const ownerChat =
      item?.type === 'privateChat'
        ? item.participants.find(
            (participant: any) => participant.user.user_name !== userName,
          )?.user.name_and_family
        : item.type === 'savedMessages'
          ? i18n.t('savedMessage')
          : item.title;

    const ShowName = ownerChat
      ? ownerChat.length > 25
        ? ownerChat.substring(0, 23) + '...'
        : ownerChat
      : '';

    const status =
      item?.type !== 'privateChat'
        ? ''
        : item.participants.find(
            (participant: any) => participant.user.user_name !== userName,
          )?.user.status;

    const situation =
      item?.type !== 'privateChat'
        ? ''
        : item.participants.find(
            (participant: any) => participant.user.user_name !== userName,
          )?.user.situation;

    const avatar =
      item?.type === 'group' || item?.type === 'channel'
        ? ''
        : item?.type === 'savedMessages'
          ? '37329gb39782gd3gbd382gd@@saved_messages_pic.png'
          : item.participants.find(
              (participant: any) => participant.user.user_name !== userName,
            )?.user.avatar;

    return (
      <View
        style={
          item?.id === chatInfo?.chatId
            ? [
                styles.selectContainer,
                { flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row' },
              ]
            : [
                styles.container,
                { flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row' },
              ]
        }
      >
        <Button
          flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
          classes={[
            styles.list,
            { flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row' },
          ]}
          onClick={() => {
            Platform.isDesktop
              ? handleChatInfo(ownerChat, item, status)
              : navigation.navigate(routesName.CHAT, {
                  conversationId: item?.id,
                  name: ownerChat,
                  avatar: avatar,
                  status: status,
                  unread: item?.totalUnread,
                });
          }}
        >
          <Avatar
            openImage={false}
            radius={80}
            size={75}
            status={status}
            statusShow={true}
            source={avatar}
            situation={situation}
          />
          <Spacing horizontal={10} />
          <View style={styles.listDesc}>
            <Typography
              classes={{
                alignSelf: lang === 'fa-IR' ? 'flex-end' : 'flex-start',
              }}
              text={ShowName}
              color={colors.primaryColor}
              weight={'bold'}
              size={16}
            />
            <Spacing vertical={7} />

            <Typography
              text={lastMessage}
              color={colors.lastMessage}
              weight={item?.totalUnread > 0 && whoMustRead ? 'bold' : 'normal'}
              classes={{
                alignSelf: lang === 'fa-IR' ? 'flex-end' : 'flex-start',
              }}
            />
          </View>
        </Button>
        <View style={(styles.timeMessage, { left: 0, top: 12 })}>
          <Typography
            textAlign={lang === 'fa-IR' ? 'left' : 'right'}
            text={time}
            color={colors.primaryColor}
          />
          <Spacing vertical={4} />
          <View
            style={{ flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row' }}
          >
            {item?.tagged && (
              <Typography
                text={'@'}
                color={colors.menu}
                weight={'bold'}
                size={17}
                classes={styles.unread}
              />
            )}

            <Spacing horizontal={3} />
            {item?.totalUnread && whoMustRead ? (
              <Typography
                text={item?.totalUnread}
                color={colors.menu}
                weight={'bold'}
                size={17}
                classes={styles.unread}
              />
            ) : null}
          </View>

          {!whoMustRead ? (
            lastMessageStatus ? (
              <MaterialCommunityIconsX
                size={20}
                color={colors.secondryColor}
                name={'check-all'}
                style={{
                  padding: 2,
                }}
              />
            ) : (
              <MaterialIconsX
                size={20}
                color={colors.secondryColor}
                name={'check'}
                style={{
                  padding: 2,
                }}
              />
            )
          ) : null}
          {item.isPinned && (
            <FontistoX size={20} name="pinboard" color={colors.secondryColor} />
          )}
        </View>
      </View>
    );
  };

  return (
    <Container classes={{ direction: 'ltr' }}>
      <MainHeader
        setOpen={setOpen}
        setSearchText={setSearchText}
        navigation={navigation}
      />
      <TabView
        navigationState={{ index, routes }}
        renderScene={renderScene}
        onIndexChange={setIndex}
        renderTabBar={(props) => (
          <TabBar
            {...props}
            indicatorStyle={{
              backgroundColor: theme === 'white' ? 'black' : 'pink',
            }}
            style={{
              backgroundColor: colors.menu,
              direction: 'ltr',
            }}
            labelStyle={{
              color: theme === 'white' ? 'black' : 'white',
              fontWeight: 'bold',
            }}
          />
        )}
      />
      <FloatButton onClick={handleButtonPress}>
        <MaterialIconsX name="edit" size={25} color={colors.white} />
      </FloatButton>
    </Container>
  );
};

const useStyles = createUseStyles(({ colors, theme }) => ({
  container: {
    justifyContent: 'space-between',
    borderBottomColor: '#ccc',
    padding: 10,
  },
  selectContainer: {
    justifyContent: 'space-between',
    borderBottomColor: '#ccc',
    padding: 10,
    backgroundColor: colors.contactSelect,
  },
  list: {
    width: '80%',
  },
  listStyle: {
    flex: 1,
  },
  listDesc: {
    flexDirection: 'column',
    padding: 15,
  },

  timeMessage: {
    position: 'absolute',
  },
  unread: {
    backgroundColor: '#B6BBC4',
    borderRadius: 40,
    padding: 5,
    minWidth: 30,
    textAlign: 'center',
  },
  floatButton: {
    position: 'absolute',
    bottom: 20,
    height: 40,
    width: 40,
    borderRadius: 50,
    backgroundColor: colors.secondryColor,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-end',
  },
}));

export { ConversationScreen };
